"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("nav-frontend-lukknapp-style");
const cls = (bla, hvit, hjorne, className) => (0, classnames_1.default)("lukknapp", {
    "lukknapp--hvit": hvit,
    "lukknapp--bla": bla,
    "lukknapp--overstHjorne": hjorne,
}, className);
/**
 * Lukknapp
 */
class Lukknapp extends React.Component {
    constructor(props) {
        super(props);
        this.focus = this.focus.bind(this);
    }
    focus() {
        if (this.buttonRef) {
            this.buttonRef.focus();
        }
    }
    render() {
        const _a = this.props, { children, bla, hvit, overstHjorne, className, ariaLabel } = _a, props = __rest(_a, ["children", "bla", "hvit", "overstHjorne", "className", "ariaLabel"]);
        return (React.createElement("button", Object.assign({ ref: (buttonRef) => {
                this.buttonRef = buttonRef;
            }, className: cls(bla, hvit, overstHjorne, className), "aria-label": ariaLabel }, props),
            React.createElement("span", { className: "text-hide" }, children)));
    }
}
Lukknapp.defaultProps = {
    children: "Lukk",
    bla: false,
    hvit: false,
    overstHjorne: false,
};
Lukknapp.defaultProps = {
    children: "Lukk",
    bla: false,
    hvit: false,
    overstHjorne: false,
};
Lukknapp.propTypes = {
    /**
     * Tekst som beskriver knappen for skjermleser
     */
    children: PT.string,
    /**
     * Blå variant
     */
    bla: PT.bool,
    /**
     * Hvit variant
     */
    hvit: PT.bool,
    /**
     * Plasser knappen øverst i høyre hjørne.
     * Knappen er absolut possisjonert og trenger derfor litt hjelp med å legge seg riktig sted.
     */
    overstHjorne: PT.bool,
    /**
     * Egendefinert klassenavn
     */
    className: PT.string,
    /**
     * @deprecated Bruk children i stedet.
     */
    ariaLabel: PT.string,
};
exports.default = Lukknapp;
